export const BASE_URL =
  process.env.REACT_APP_ENV === "DEV"
    ? `https://provider.youngsoft.in/`
    : `https://provider.youngsoft.in/`;

export const API_MEDIC = "https://healthservice.priaid.ch/";

export const YSI_DIAGNOSIS = "https://diagnosis.api.youngsoft.in/";
